import { api } from '@/utils';

export default {
  name: 'ProductDetail',
  components: {},
  props: {},
  data: () => ({
    loading: false,
    apiVersion: 1,
    id: '',
    name: '',
    unNumber: '',
    imoClass: '',
    formFields: {
      id: {
        name: 'id',
        label: 'Code',
        validation: 'required',
      },
      name: {
        name: 'name',
        label: 'Name',
      },
      unNumber: {
        name: 'unNumber',
        label: 'Un number',
      },
      imoClass: {
        name: 'imoClass',
        label: 'Imo class',
      },
    },
  }),
  computed: {
    isDetail() {
      return this.$route.params.id != null;
    },
  },
  methods: {
    saveProductForm() {
      this.$validator.validateAll()
        .then((isValid) => {
          if (isValid) {
            this.loading = true;

            const postObject = {
              id: this.id,
              name: this.name,
              unNumber: this.unNumber,
              imoClass: this.imoClass,
            };

            // BASEURL
            const url = `/products/${this.id}`;

            api.put(url, postObject)
              .then(() => {
                this.loading = false;
                this.$router.push({ name: 'product-overview' });

                if (this.isDetail) {
                  this.$eventHub.$emit('show-snackbar', 'Product was updated');
                } else {
                  this.$eventHub.$emit('show-snackbar', 'Product was created');
                }
              })
              .catch((error) => {
                this.loading = false;
                console.log('something went wrong');
                this.$eventHub.$emit('show-snackbar', error);
              });
          }
        });
    },
    getProduct() {
      if (this.$route.params.id != null) {
        // BASEURL
        const url = `/products?code=${this.$route.params.id}`;

        api.get(url)
          .then((response) => {
            response.data.forEach((element) => {
              if (element.id === this.$route.params.id) {
                this.id = element.id;
                this.name = element.name;
                this.unNumber = element.unNumber;
                this.imoClass = element.imoClass;
              }
            });
          })
          .catch((error) => {
            this.$eventHub.$emit('show-snackbar', error);
          });
      }
    },
    cancelProductForm() {
      this.$router.push({ name: 'product-overview' });
    },
  },
  created() {
    this.getProduct();
  },
};
